import { render, staticRenderFns } from "./indexJs.vue?vue&type=template&id=fc8406c4&scoped=true"
import script from "./indexJs.vue?vue&type=script&lang=js"
export * from "./indexJs.vue?vue&type=script&lang=js"
import style0 from "./indexJs.vue?vue&type=style&index=0&id=fc8406c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8406c4",
  null
  
)

export default component.exports